(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    const mediaQueryLarge = matchMedia('(min-width: 750px)');

    function positionGridCTA(grid) {
      const cta = grid.querySelector('.product-grid__cta');
      if (!cta) return;

      const ctaRow = !mediaQueryLarge.matches
        ? parseInt(cta.dataset.ctaRowMobile, 10) || parseInt(cta.dataset.ctaRow, 10)
        : parseInt(cta.dataset.ctaRow, 10);
      if (!ctaRow || ctaRow < 1) return;

      const colStr = getComputedStyle(grid).gridTemplateColumns;
      if (!colStr) return;

      const columnCount = colStr.trim().split(/\s+/).length;
      if (columnCount < 1) return;

      const items = [...grid.querySelectorAll('.product-grid__item')];
      if (items.length === 0) return;

      const targetIndex = Math.min(ctaRow * columnCount, items.length) - 1;
      const targetItem = items[targetIndex];

      if (cta.previousElementSibling !== targetItem) {
        targetItem.after(cta);
      }
      cta.classList.add('is-positioned');
    }

    function positionAllGridCTAs() {
      document.querySelectorAll('.product-grid').forEach(positionGridCTA);
    }

    document.addEventListener('DOMContentLoaded', positionAllGridCTAs, { once: true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(positionAllGridCTAs, 100);
    });

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', positionAllGridCTAs);
    } else {
      const resultsEl = document.querySelector('results-list');
      if (resultsEl) {
        let mutationTimer;
        new MutationObserver(() => {
          clearTimeout(mutationTimer);
          mutationTimer = setTimeout(positionAllGridCTAs, 50);
        }).observe(resultsEl, { childList: true, subtree: true });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
